import script from "./SegmentWorkflow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SegmentWorkflow.vue?vue&type=script&lang=ts&setup=true"

import "./SegmentWorkflow.vue?vue&type=style&index=0&id=5335ef6a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5335ef6a"]])

export default __exports__